module.exports = __webpack_public_path__ + "assets/images/announcement-desk-occupancy-detection-mode.png";